var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("router-link", { attrs: { to: "/" } }, [
    _c(
      "div",
      { staticClass: "banner--container", attrs: { title: "Home" } },
      [
        _c("IconBanner", { staticClass: "banner--icon" }),
        _vm._v(" "),
        _c("div", { staticClass: "banner--text" }, [_vm._v("ACPatterns")]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }